<div>
    <mat-expansion-panel class="light-flex-card tv-mat-expansion-indicator-light-bg">
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Informations générales
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">

            <!-- 1st line -->
            <div class="line-container">

                <!-- Annonceur -->
                <div class="first-line-bloc-container">
                    <div class="first-bloc-container">
                        <span class="third-title">Annonceur</span>

                        <app-contract-advertiser-informations
                                [contractItemInformations]="contractItemInformations">
                        </app-contract-advertiser-informations>

                    </div>
                </div>

                <!-- Gestionnaire(s) du contrat -->
                <div class="first-line-bloc-container">
                    <div class="first-bloc-container">
                        <span class="third-title">Gestionnaire(s) du contrat</span>

                        <app-contract-manager-informations
                                [contractItemInformations]="contractItemInformations">
                        </app-contract-manager-informations>

                    </div>
                </div>

                <!-- UT -->
                <div class="first-line-bloc-container">
                    <div class="first-bloc-container">
                        <span class="third-title">UT</span>
                        <div class="full-size-category">

                            <app-contract-ut-informations
                                    [contractItem]="contractItem"
                                    [contractUserList]="contractUserList">
                            </app-contract-ut-informations>

                        </div>
                    </div>
                </div>

            </div>

            <!-- 2nd line -->
            <div class="line-container">

                <!-- Contrat -->
                <div class="second-line-container">
                    <div class="second-bloc-container">
                        <span class="third-title">Contrat</span>
                        <div class="full-size-category">

                            <app-contract-informations
                                    [contractItemInformations]="contractItemInformations">
                            </app-contract-informations>

                        </div>
                    </div>

                    <!-- Autres Centrales -->
                    <div class="second-bloc-container">
                        <span class="third-title">Autres Centrales</span>
                        <div class="full-size-category">

                            <app-contract-advertising-center-informations
                                    [contractOtherCentralAgencyList]="contractOtherCentralAgencyList">
                            </app-contract-advertising-center-informations>

                        </div>
                    </div>
                </div>

            </div>

            <div class="action-buttons-container">
                <button
                        class="tv-ns-secondary-large-button-on-light-bg"
                        (click)="cancelFormsModification()">
                    Annuler
                </button>
                <button
                        class="tv-ns-validation-large-button"
                        [disabled]="isSaving"
                        (click)="saveFormsModification()">
                    Valider
                </button>
                <div *ngIf="isSaving"
                     class="main-validation-container" id="onLoading">
                    <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
                </div>
            </div>

        </div>
    </mat-expansion-panel>
</div>
